import React, { Component } from 'react';
import { Text } from '../../UI/Text';
import { secondsMinutesFormat, secondsHoursFormat } from '../../../Utils/timeConvertorHelper';

// TODO: make reusable
export class Countdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            secondsLeft: props.countdownStart,
        };
    }

    componentDidMount() {
        this.startCountdown();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.key !== this.props.key) {
            this.startCountdown();
        }
    }

    startCountdown = () => {
        this.countdown = setInterval(() => {
            this.tick();
        }, 1000);
    };

    tick = () => {
        this.setState(
            prevState => {
                if (prevState.secondsLeft === -1) return;
                return {
                    secondsLeft: --prevState.secondsLeft,
                };
            },
            () => {
                if (this.state.secondsLeft === -1) {
                    clearInterval(this.countdown);
                }
            },
        );
    };

    componentWillUnmount() {
        clearInterval(this.countdown);
    }

    render() {
        const { secondsLeft } = this.state;
        return (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                {secondsLeft >= 3600 && (
                    <Text weight={'bold'} size={'6vw'}>
                        {secondsHoursFormat(secondsLeft)}
                    </Text>
                )}
                {secondsLeft > 60 &&
                    secondsLeft < 3600 && (
                        <Text weight={'bold'} size={'10vw'}>
                            {secondsMinutesFormat(secondsLeft)}
                        </Text>
                    )}
                {secondsLeft <= 60 && (
                    <Text weight={'bold'} size={'15vw'}>
                        {secondsLeft}
                    </Text>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Countdown/index.js